import { render, staticRenderFns } from "./MdTablePaginationClient.vue?vue&type=template&id=f3b54336&scoped=true&"
import script from "./MdTablePaginationClient.vue?vue&type=script&lang=js&"
export * from "./MdTablePaginationClient.vue?vue&type=script&lang=js&"
import style0 from "./MdTablePaginationClient.vue?vue&type=style&index=0&id=f3b54336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b54336",
  null
  
)

export default component.exports